<template>
    <v-tooltip v-if="hasDiscounts" bottom open-on-hover content-class="myprovet-tooltip">
        <template v-slot:activator="{ on, attrs }">
            <v-icon :class="inTable ? 'pl-0 mb-1' : ''" small v-on="on" v-bind="attrs" class="dark-blue-color ml-1">mdi-information</v-icon>
        </template>

        <div>{{ $t('productInfo.agreement') }}</div>

        <template v-for="index in 6">
            <span v-if="hasDiscountAt(index)" :key="index">
                <span>{{ parseFloat(getDiscountAt(index)) }}%</span>

                <span v-if="hasDiscountAfter(index)">+&nbsp;</span>
            </span>
        </template>
    </v-tooltip>
    <div v-else style="width: 20px !important; min-width: 20px !important; max-width: 20px !important"></div>
</template>

<script>
const TOTAL_DISCOUNT_FIELDS = 6;

export default {
    props: {
        product: {
            type: Object,
            required: true,
        },
        inTable: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        hasDiscounts() {
            const discounts = [];

            if (this.product?.discounts_restricted) {
                return false;
            }

            for (let i = 1; i <= TOTAL_DISCOUNT_FIELDS; ++i) {
                const property = 'discount' + i;
                discounts.push(property);
            }

            return discounts.some((it) => it in this.product && this.product[it] !== 0);
        },
    },

    methods: {
        hasDiscountAt(index) {
            const property = 'discount' + index;
            return property in this.product && this.product[property] !== 0;
        },

        getDiscountAt(index) {
            const property = 'discount' + index;
            return this.product[property];
        },

        hasDiscountAfter(index) {
            for (let i = index + 1; i <= TOTAL_DISCOUNT_FIELDS; ++i) {
                if (this.hasDiscountAt(i)) {
                    return true;
                }
            }

            return false;
        },
    },
};
</script>
